import { useQuery } from "react-query";
import http  from 'infra/http';
import { PaginateResult } from 'core/resources/types/shared';

function useMarcaEquipamento(search?: string) {
  return useQuery(["/v1/marca-equipamento", search], async () => {
    const { data } = await http.get<PaginateResult<{id: string;nome: string}>>(
      "/v1/marca-equipamento", {
        params: {
          search
        }
      }
    );

    return data;
  });
}

export default useMarcaEquipamento;
